
/**
 * * @module component/swiper.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";

import Swiper from "swiper";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const SwiperInstances = backbone.View.extend({
  el: $(document),
  

  events: {
    "click .swiper-go-first": "goToFirstSlide",
    "click .swiper-go-last": "goToLastSlide",
  },

  initialize: function () {
    this.swiper = null;
    this.breakpoint = window.matchMedia("(min-width: 768px)");

    this.render();
  },

  goToFirstSlide: function() {
    if (!this.swiper) return;

    this.swiper.slideTo(0, 1000);
  },

  goToLastSlide: function (e) {
    if (!this.swiper) return;

    const lastIndex = this.swiper.slides.length - this.swiper.params.slidesPerView;
    this.swiper.slideTo(lastIndex, 1000, true);
  },

  updateCustomPagination: function(){
    if(!this.swiper) return;

    const customEl = this.swiper.el.querySelector(".swiper-pagination-custom");
    const totalSlides = Array.from(this.swiper.slides).filter(slider => !slider.classList.contains("instances__item--hide")).length;
    const showing = Math.min(this.swiper.activeIndex + this.swiper.params.slidesPerView, totalSlides);

    if(customEl) customEl.textContent = `Showing ${showing} of ${totalSlides} events`;

    const firstBtn = this.swiper.el.querySelector(".swiper-go-first");
    const lastBtn = this.swiper.el.querySelector(".swiper-go-last");

    if(firstBtn) firstBtn.disabled = this.swiper.activeIndex === 0;
    if(lastBtn) lastBtn.disabled = this.swiper.activeIndex >= totalSlides - this.swiper.params.slidesPerView;

  },

  enableSwiper: function () {
    if (this.swiper) return;

    const el = document.querySelector(".swiper--instances");
    if (!el) return;

    this.swiper = new Swiper(el, {
      modules: [Pagination],

      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      enabled: true,

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1
      },
      breakpoints: {
        510: {
          slidesPerView: 2,
        }
      },
      on: {
        init: (swiper) => {
          this.updateCustomPagination();

          swiper.on("slideChange", () => {
            this.updateCustomPagination();
          });
        }
      }
    });

  },

  destroySwiper: function () {
    if (!this.swiper) return;

    this.swiper.destroy(true, true);
    this.swiper = null;
  },

  breakpointChecker: function () {
    if (this.breakpoint.matches) {
      this.destroySwiper();
    } else {
      this.enableSwiper();
    }
  },

  initSwiper: function () {
    if (!$(".swiper--instances").length) return;

    this.breakpoint.addEventListener("change", this.breakpointChecker.bind(this));

    this.breakpointChecker();
  },

  render: function () {
    this.initSwiper();

    if(this.swiper) {
      this.updateCustomPagination();
    }
  },

  refreshSwiper: function (){
    if(!this.swiper) return;

    this.swiper.update();
    this.swiper.slideTo(0);
    this.updateCustomPagination();
  }
});

export default SwiperInstances;